<template>
    <div>
        <apexchart height="500px" type="bar" :options="chartOptions" :series="series"/>
    </div>
</template>

<script>
export default {
    props: {
        names: {
            type: Array,
            required: true,
            default: () => [],
        },
        series: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    height: 350,
                    type: 'bar',
                },
                dataLabels: {
                    enabled: false,
                },
                xaxis: {
                    categories: this.names,
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                },
            };
        },
    },
};
</script>

<style>

</style>
  